import React, { useEffect, useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { formatDateTime } from "../utils"; // путь из /modals к utils

const InactivePartners = () => {
  const [inactivePartners, setInactivePartners] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [visibleCount, setVisibleCount] = useState(10);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${apiUrl}/admin/analytics/inactive-partners`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Ошибка загрузки");
        const data = await res.json();
        setInactivePartners(data || []);
      } catch (e) {
        console.error("Ошибка соединения с сервером:", e);
      }
    })();
  }, [apiUrl]);

  const handleShowMore = () => setVisibleCount((n) => n + 10);
  const handleClose = () => {
    setShowModal(false);
    setVisibleCount(10);
  };

  const safeDate = (d) => (d ? formatDateTime(d, true) : "—");

  if (!inactivePartners.length) return null;

  return (
    <>
      <div className="notice-banner">
        <div>
          <p className="notice-banner__eyebrow">Внимание</p>
          <p className="notice-banner__title">
            Несколько партнёров не делали заказ больше месяца
          </p>
        </div>
        <div className="notice-banner__actions">
          <span className="notice-chip">{inactivePartners.length}</span>
          <Button className="btn-rounded" variant="outline-danger" onClick={() => setShowModal(true)}>
            Показать
          </Button>
        </div>
      </div>

      {/* Модалка со списком */}
      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title>Неактивные партнёры</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 56 }}>#</th>
                  <th>Имя партнёра</th>
                  <th>Последний заказ</th>
                  <th style={{ width: 80 }}></th>
                </tr>
              </thead>
              <tbody>
                {inactivePartners.slice(0, visibleCount).map((p, i) => (
                  <tr key={`${p.unique_id}-${i}`}>
                    <td>{i + 1}</td>
                    <td>{p.name || "—"}</td>
                    <td>{safeDate(p.last_order_date)}</td>
                    <td className="text-center">
                      <Link to={`/admin/partner/${p.unique_id}`} className="btn btn-ghost" title="Открыть карточку">
                        <FaEye />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {visibleCount < inactivePartners.length && (
            <div className="d-flex justify-content-center mt-2">
              <Button className="btn-ghost" variant="outline-secondary" onClick={handleShowMore}>
                Показать ещё
              </Button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="outline-secondary" onClick={handleClose}>
            Закрыть
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InactivePartners;
